import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.miniStressScoring.loading;
export const selectMiniStressErrorMessage = (state: RootState) =>
  state.miniStressScoring.error;
export const miniStressScoringResponse = (state: RootState) =>
  state.miniStressScoring.miniStressScoringResponse;
